export default {
	ADD: 'Add',
	EDIT: 'Edit',
	ADD_DROP: 'Add drop'
};
